module.exports = __webpack_public_path__ + "static/themes-accents-do-b78f7057f30f6a19b541505b53044c90.png";